import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col text-center" }
const _hoisted_3 = {
  key: 1,
  class: "row"
}
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "table table-bordered" }
const _hoisted_8 = { class: "text-center p-0 m-0" }
const _hoisted_9 = {
  key: 0,
  class: "row"
}
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "row alert alert-info mx-1 px-0"
}
const _hoisted_13 = { class: "col" }
const _hoisted_14 = { class: "d-grid gap-2 d-md-flex justify-content-md-end mt-4" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 0,
  class: "spinner-border spinner-border-sm mb-1",
  role: "status",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_help = _resolveComponent("help")!
  const _component_sub_section = _resolveComponent("sub-section")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_sub_section, {
      title: "Could buying some guaranteed income help?",
      showHelp: false
    }, {
      default: _withCtx(() => [
        (_ctx.showOfferToCheck)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "row" }, [
                _createElementVNode("div", { class: "col" }, [
                  _createElementVNode("p", null, " Some tests below show shortfalls. Using some of your non protected pots to buy some guaranteed income may remove these without having to take less or pay more. Would you like to try this? ")
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("button", {
                    class: "btn btn-success mx-3",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onLetsSeeClicked && _ctx.onLetsSeeClicked(...args))),
                    "aria-label": "Let's see if buying some guaranteed income could help resolve some of the shortfalls in the test scenarios."
                  }, " Let's see ")
                ])
              ])
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("p", null, [
                  _createTextVNode(_toDisplayString(_ctx.subscriptionText) + " ", 1),
                  _createVNode(_component_help, {
                    title: "Guaranteed income",
                    text: _ctx.HelpText.guaranteedIncome(_ctx.annuityType)
                  }, null, 8, ["text"])
                ])
              ])
            ]))
      ]),
      _: 1
    }),
    _createVNode(_component_modal, {
      ref: "guaranteedIncomeModal",
      title: "Test with guaranteed income",
      idKey: "allScenarioGuaranteedIncomeModal",
      "close-button-aria-label": _ctx.modalCloseButtonAriaLabel
    }, {
      default: _withCtx(() => [
        (_ctx.isEvaluating)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "row" }, [
                _createElementVNode("div", { class: "col" }, [
                  _createElementVNode("p", null, "Evaluating...")
                ])
              ], -1)),
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "row" }, [
                _createElementVNode("div", { class: "col text-center" }, [
                  _createElementVNode("div", {
                    class: "spinner-border",
                    role: "status"
                  }, [
                    _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                  ])
                ])
              ], -1))
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("table", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeScenarios, (activeScenario) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: activeScenario.scenarioType
                      }, [
                        _createElementVNode("td", null, " Scenario " + _toDisplayString(activeScenario.number) + " - " + _toDisplayString(_ctx.getScenarioName(activeScenario.scenarioType)), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("p", _hoisted_8, [
                            _createElementVNode("i", {
                              class: _normalizeClass(["bi fs-1", _ctx.exclaimationOrCheck(activeScenario.outcome)])
                            }, null, 2)
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              (!_ctx.isEvaluating)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.outcomeMessage), 1),
                      (_ctx.isViable)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_11, "Do you want to include this in your plan?"))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.hasError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.errorMessage), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 64)),
        _createElementVNode("div", _hoisted_14, [
          (_ctx.showYesButton)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                disabled: !_ctx.yesBtnEnabled,
                class: "btn px-5 btn-secondary",
                "aria-label": "Yes",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onYesClicked && _ctx.onYesClicked(...args)))
              }, [
                _cache[6] || (_cache[6] = _createTextVNode(" Yes ")),
                (_ctx.implementingSolution)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_15))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "button",
            class: "btn px-5 btn-secondary",
            "aria-label": "No",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onCloseClicked && _ctx.onCloseClicked(...args)))
          }, _toDisplayString(_ctx.noButtonText), 1)
        ])
      ]),
      _: 1
    }, 8, ["close-button-aria-label"])
  ], 64))
}